import React from "react";

// App context 
// To manage data state between components
const AppContext = React.createContext();

export default AppContext;